/**
 * Largura de texto para dimensionar os inputs do editor.
 *
 * Usa a mesma métrica do PDF (fontkit sobre os TTFs da Montserrat), e não o
 * `measureText` do canvas: medir numa engine e desenhar em outra foi
 * justamente o que produziu as âncoras compensatórias do handler legado.
 * O canvas fica só como fallback enquanto o preload das fontes não termina.
 */
import { getFonts, stringWidth } from "./limitString";

let ctx;

// jsdom não implementa getContext; nesse caso cai na estimativa por caractere.
const getCtx = () => {
  if (ctx !== undefined) return ctx;
  try {
    ctx = document.createElement("canvas").getContext("2d") || null;
  } catch {
    ctx = null;
  }
  return ctx;
};

const fontKeyFor = (fontFamily, fontWeight) => {
  if (/Montserrat-Bold/i.test(fontFamily)) return "bold";
  if (/Montserrat/i.test(fontFamily)) return "light";
  // Helvetica/Arial do layout simples não tem TTF carregado.
  return Number(fontWeight) >= 600 ? "bold" : null;
};

const measureScreenTextWidth = (text, fontFamily, fontSize, fontWeight = "normal") => {
  const value = String(text ?? "");
  const fonts = getFonts();
  const key = fonts ? fontKeyFor(fontFamily, fontWeight) : null;
  if (key && fonts[key]) return stringWidth(fonts[key], value, fontSize);

  const context = getCtx();
  if (!context) return value.length * fontSize * 0.55;
  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  return context.measureText(value).width;
};

export { measureScreenTextWidth };
